import { Nfc, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { SITE } from "../../lib/site";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative pt-20 pb-10 border-t border-white/10 bg-gradient-to-b from-transparent to-black"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-10">
                <div className="text-center mb-14">
                    <h3 className="font-display text-4xl sm:text-6xl font-light tracking-tighter">
                        Ready to grow?
                    </h3>
                    <p className="text-zinc-400 mt-4 max-w-md mx-auto text-sm">
                        Request a quote &mdash; ships in 2-3 days.
                    </p>
                    <a href="#top">
                        <Button
                            data-testid="footer-cta"
                            className="mt-7 rounded-full bg-blue-600 hover:bg-blue-500 text-white h-11 px-7 shadow-[0_0_30px_rgba(37,99,235,0.4)]"
                        >
                            Get a Quote <ArrowRight className="w-4 h-4 ml-2" />
                        </Button>
                    </a>
                </div>

                <div className="grid md:grid-cols-3 gap-8 py-8 border-t border-white/10">
                    <div>
                        <div className="flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg bg-blue-600/20 border border-blue-500/40 flex items-center justify-center">
                                <Nfc className="w-4 h-4 text-blue-400" strokeWidth={1.8} />
                            </span>
                            <span className="font-display text-lg font-medium">
                                NFC<span className="text-blue-500">Pro</span>
                            </span>
                        </div>
                        <p className="text-xs text-zinc-500 mt-3 max-w-xs">
                            Premium NFC plaques for modern businesses. Tap. Connect. Grow.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                            <div className="text-xs uppercase tracking-widest text-zinc-500 mb-3">
                                Products
                            </div>
                            <ul className="space-y-2 text-zinc-400">
                                <li><a href="#explore" className="hover:text-white">Standing Card</a></li>
                                <li><a href="#explore" className="hover:text-white">Plaque</a></li>
                                <li><a href="#explore" className="hover:text-white">Sticker</a></li>
                            </ul>
                        </div>
                        <div>
                            <div className="text-xs uppercase tracking-widest text-zinc-500 mb-3">
                                Explore
                            </div>
                            <ul className="space-y-2 text-zinc-400">
                                <li><a href="#explore" className="hover:text-white">How it works</a></li>
                                <li><a href="#explore" className="hover:text-white">Gallery</a></li>
                                <li><a href="#explore" className="hover:text-white">FAQ</a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="text-sm text-zinc-400">
                        <div className="text-xs uppercase tracking-widest text-zinc-500 mb-3">
                            Get in touch
                        </div>
                        <div>{SITE.phone}</div>
                        <a href={`mailto:${SITE.email}`} className="hover:text-white">
                            {SITE.email}
                        </a>
                    </div>
                </div>

                <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-zinc-500">
                    <div>© {new Date().getFullYear()} {SITE.brand}. All rights reserved.</div>
                    <div>{SITE.domain}</div>
                </div>
            </div>
        </footer>
    );
}
